import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
@Injectable()
export class AuthGuard {
  constructor(
      public jwtHelper: JwtHelperService,
      private router: Router
  ) {}

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    if (token){
      return !this.jwtHelper.isTokenExpired(token);
    }else{
      return false;
    }
  }

  /* get token from local storage */
  public getToken(): string {
    return localStorage.getItem('token');
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.isAuthenticated()) {
      return true;
    } else{
      this.router.navigate(['/login']);
    }
  }

}
